import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import { Grey2 } from '../../color_utils';
import { trakrefFontFamily } from '../../utils';

const Text = ({
    text,
    variant,
    fontSize,
    marginBottom,
    align,
}) => (
    <>
        <Typography
            variant={variant}
            sx={{ '&.MuiTypography-root': { fontFamily: trakrefFontFamily, fontSize: fontSize } }}
            style={{ marginBottom: `${marginBottom}%`, color: Grey2 }}
            align={align}
        >
            {text}
        </Typography>
    </>
);

Text.propTypes = {
    text: PropTypes.string.isRequired,
    variant: PropTypes.string,
    fontSize: PropTypes.string,
    marginBottom: PropTypes.number,
    align: PropTypes.string,
};

Text.defaultProps = {
    variant: "h1",
    fontSize: "14px",
    marginBottom: 1,
    align: "center",
};

export default Text;
